import { render, staticRenderFns } from "./ModalDisplayWeeklyHistogram.vue?vue&type=template&id=8a1a37ba"
import script from "./ModalDisplayWeeklyHistogram.vue?vue&type=script&lang=js"
export * from "./ModalDisplayWeeklyHistogram.vue?vue&type=script&lang=js"
import style0 from "./ModalDisplayWeeklyHistogram.vue?vue&type=style&index=0&id=8a1a37ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports